"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onContactsChange = void 0;
const generate_contact_1 = require("../lib/contacts/generate-contact");
const generate_contacts_1 = require("../lib/contacts/generate-contacts");
let contacts = [];
const eventName = 'contacts';
const subscribers = {};
const publish = (contacts) => {
    if (!Array.isArray(subscribers[eventName]))
        return;
    subscribers[eventName].forEach((callback) => {
        callback(contacts);
    });
};
const onContactsChange = (callback, options) => {
    if (!Array.isArray(subscribers[eventName])) {
        subscribers[eventName] = [];
    }
    const contactOptions = {
        alertsPercentage: options?.alertsPercentage,
        dateRef: options?.dateRef,
        daysRange: options?.daysRange,
        secondAlertPercentage: options?.secondAlertPercentage,
    };
    subscribers[eventName].push(callback);
    contacts.push(...(0, generate_contacts_1.generateContacts)(options?.initial, contactOptions));
    publish(contacts);
    const limit = options?.limit || 200;
    const index = subscribers[eventName].length - 1;
    const interval = setInterval(() => {
        if (contacts.length >= limit)
            return;
        contacts.push((0, generate_contact_1.generateContact)(contacts.length - 1, contactOptions));
        publish(contacts);
    }, (options?.interval || 5) * 1000);
    return () => {
        clearInterval(interval);
        subscribers[eventName].splice(index, 1);
        contacts = [];
    };
};
exports.onContactsChange = onContactsChange;
